import { UNIQUE_WINDOW_IDENTIFIER } from '../constants'

// When multiple widgets (and multiple bootstrapper scripts) are loaded on the same page,
// this tells each copy whether it is the first one, so page-level side effects
// (iframe styles, GA listener) only run once. Every copy still scans for snippets.
export function setAndCheckUniqueIdentifier() {
  if (window[UNIQUE_WINDOW_IDENTIFIER]) {
    return true
  }

  window[UNIQUE_WINDOW_IDENTIFIER] = true
  return false
}
